<template>
  <div id="cashier" :class="customStyle">
    <div class="left">
      <div v-for="item in buttons" :key="item.dom">
        <div
          :style="active === item.dom ? setBorder : null"
          :ref="item.dom"
          v-if="item.condition"
          class="btn"
          @click="scrollTo(item.dom)"
        >
          <i :class="item.icon" />
          <div class="btn-label">{{ item.title}}</div>
        </div>
      </div>
    </div>
    <div
      class="right promo__right"
      v-if="$store.state.isPromo && is_promo"
      @click="$emit('status', 1)"
    >
      <button id="cashier-button" :class="{ lifted: label }">
        <span>
          <i class="anyteachicon anyteach-1212 promo-icon" />
          {{ $store.state.promoData.btn2 }}
        </span>
      </button>
    </div>
    <div class="right" v-else @click="$emit('status', 1)">
      <button :style="setBgd" ref="pay" id="cashier-button" :class="{ lifted: label }">
        <span>购课</span>
      </button>
      <span v-if="label" id="tag">{{ label }}</span>
    </div>
  </div>
</template>

<script>
import mixin from "./mixin"
export default {
  name: "Cashier",
  props: {
    customStyle: String,
    color: {
      type: String,
      default: "#ed254e",
    },
    title: String,
    subtitle: String,
    price: String,
    label: String,
    is_promo: Number,
    articles: {
      type: Boolean,
      default: false
    },
    comments: {
      type: Boolean,
      default: false
    },
    videos: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      active: null,
      disableListening: false,
      buttons: [
        {
          condition: this.articles,
          dom: "articles",
          icon: "anyteachicon anyteach-chuangxindian",
          title: "理念",
        },
        {

          condition: this.videos,
          dom: "videos",
          icon: "anyteachicon anyteach-bofang1",
          title: "视频",
        },
        {

          condition: this.comments,
          dom: "comments",
          icon: "anyteachicon anyteach-daipingjia",
          title: "评价",
        },
        {

          condition: true,
          dom: "share",
          icon: "anyteachicon anyteach-ArtboardCopy",
          title: "分享",
        },
      ]
    }
  },
  mixins: [mixin],
  methods: {
    scrollTo(domId) {
      this.disableListening = true
      const el = document.getElementById(domId)
      if (!el) return
      this.active = domId
      if (el.scrollIntoView) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "start"
        })
      } else {
        window.scrollTo({
          top: el.offsetTop,
          left: 0,
          behavior: "smooth",
        })
      }
      setTimeout(() => {
        this.disableListening = false
        this.onScroll()
      }, 1500)
    },
    onScroll() {
      if (this.disableListening) return
      this.active = null
      this.buttons.forEach((item, index) => {
        const el = document.getElementById(item.dom)
        if (!el) return
        if (window.scrollY >= el.offsetTop - 5 && window.scrollY <= el.offsetTop + el.clientHeight) {
          this.active = item.dom
        }
      })
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll)
    this.$on("hook:beforeDestroy", () => {
      window.removeEventListener("scroll", this.onScroll)
    })
  }
}
</script>

<style scoped lang="scss">
@import "../style.scss";
@import "@/assets/css/promo.scss";
#cashier {
  transition: all 0.2s ease-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  background: white;
  z-index: 3;

  .left {
    h1 {
      font-size: 1rem;
      font-weight: bold;
      line-height: 1.4;
      margin: 3px 0 3px 0;
    }
    h2 {
      font-size: 0.85rem;
      font-weight: 400;
      @include avenir();
      color: $black;
      opacity: 0.6;
      margin: 0 0 5px 0;
    }
    .btn {
      float: left;
      text-align: center;
      transition: all 0.3s;
      border-bottom: 2px solid white;
      padding-bottom: 3px;
      padding-left: 2px;
      padding-right: 2px;
      .btn-label {
        font-size: 12px;
        @include avenir-demi();
      }
      i {
        font-size: 20px;
      }
      &:active {
        opacity: 0.6;
      }
    }
    .btn:nth-child(-n + 3) {
      margin-right: 20px;
    }
    width: calc(100% - 75px);
  }

  .right {
    position: relative;
    margin-left: 10px;
    button {
      text-align: center;
      background: $red;
      color: white;
      height: 32px;
      min-width: 60px;
      border-radius: 20px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.1s;
      border: none;
      margin-bottom: 6px;
      @include avenir-demi();

      &:disabled {
        opacity: 0.8;
        color: $grey;
        background: #eee;
      }
    }

    #tag {
      display: block;
      font-size: 12px;
      font-weight: 400;
      color: $black;
      text-align: center;
      width: 100%;
      top: 27px;
      position: absolute;
      transform: scale(0.8);
    }
  }
  .promo__right {
    button {
      background: $d11__bgd;
      color: $d11__main;
      i {
        font-size: 13px;
      }
    }
  }

  .lifted {
    margin-bottom: 13px;
  }
}

.static#cashier {
  width: 100%;
  padding: 10px 0 0 0;
}
.fixed#cashier {
  width: 90%;
  left: 5%;
  position: fixed;
  bottom: $bottom-bar;
  bottom: $iphone-x-bottom-bar;
  margin-bottom: 15px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 45px -2px #c5c5c5;
  padding: 6px 15px;
  padding-bottom: 0;
}

.bottom#cashier {
  position: fixed;
  bottom: $bottom-bar;
  bottom: $iphone-x-bottom-bar;
  width: 100%;
  left: 0;
  background: #f7f7f7;
  padding: 7px 5%;
  z-index: 3;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  .btn {
    border: none;
    padding-bottom: 0;
  }
  button {
    margin-bottom: 0;
  }
  .promo__right {
    button {
      color: $d11__bgd;
    }
  }
}
</style>
